import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {} from "@fortawesome/free-regular-svg-icons";
import {
  faGithub,
  faLinkedin,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="footer footer-center p-10 bg-neutral text-white">
      <div>
        <p className="font-bold">
          Designed and Developed by <br />
          Abdullah Al Noman
        </p>
        <p>Copyright © 2022 - All right reserved</p>
      </div>
      <div>
        <div className="grid grid-flow-col gap-4">
          <a
            href="https://github.com/alnomancs"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon color="#171515" icon={faGithub} size="2x" />
          </a>
          <a
            href="https://www.linkedin.com/in/alnomancs/"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon color="#0e76a8" icon={faLinkedin} size="2x" />
          </a>
          <a
            href="https://www.facebook.com/alnuman.cs/"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon color="#4267B2" icon={faFacebook} size="2x" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
